export enum actionTypes {
    SPORTSBOOK_START = 'SPORTSBOOK:START',
    SPORTSBOOK_STOP = 'SPORTSBOOK:STOP',
    SPORTSBOOK_BALANCES_UPDATE = 'SPORTSBOOK:BALANCES:UPDATE',
    SPORTSBOOK_INITIALIZE_ERROR = 'SPORTSBOOK:INITIALIZE:ERROR',
    SPORTSBOOK_INITIALIZED_UPDATE = 'SPORTSBOOK:INITIALIZED:UPDATE',
    SPORTSBOOK_INITIALIZING_UPDATE = 'SPORTSBOOK:INITIALIZING:UPDATE',
    SPORTSBOOK_RENDER_START = 'SPORTSBOOK:RENDER:START',
    SPORTSBOOK_INTEGRATION_SCRIPT_ERROR = 'SPORTSBOOK:INTEGRATION_SCRIPT:ERROR',
    SPORTSBOOK_INTEGRATION_SCRIPT_UPDATE = 'SPORTSBOOK:INTEGRATION_SCRIPT:UPDATE',
    SPORTSBOOK_INTEGRATION_SCRIPT_FETCHED = 'SPORTSBOOK:INTEGRATION_SCRIPT:FETCHED',
    SPORTSBOOK_INTEGRATION_SCRIPT_FETCHING = 'SPORTSBOOK:INTEGRATION_SCRIPT:FETCHING'
}
